import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../../../context/AuthContext";
import { ENDPOINTS } from "../../../../config/api";
import * as bootstrap from "bootstrap";
import Pagination from "../../../../components/private/pagination";
import SearchSelect from "../../../../components/private/searchselect";

const Assignment = () => {

  const { token, authFetch } = useContext(AuthContext);

  const [assignments, setAssignments] = useState([]);
  const [contracts, setContracts] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [costCenters, setCostCenters] = useState([]);

  // filtros
  const [filterContract, setFilterContract] = useState("");
  const [filterProgram, setFilterProgram] = useState("");
  const [filterCostCenter, setFilterCostCenter] = useState("");

  // paginación
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  let modalInstance = null;

  const [formData, setFormData] = useState({
    contract: "",
    program_assignment: "",
    cost_center: ""
  });

  // =========================
  // CARGAR DATA
  // =========================
  useEffect(() => {
    if (!token) return;

    const loadData = async () => {
      setLoading(true);

      try {
        const resAssign = await authFetch(ENDPOINTS.getAssignment);
        const resContracts = await authFetch(ENDPOINTS.getActivateContract);
        const resPrograms = await authFetch(ENDPOINTS.getProgramAssignment);
        const resCostCenters = await authFetch(ENDPOINTS.getCostCenterActive);


        if (resAssign.success) setAssignments(resAssign.data);
        if (resContracts.success) setContracts(resContracts.data);
        if (resPrograms.success) setPrograms(resPrograms.data);
        if (resCostCenters.success) setCostCenters(resCostCenters.data);

      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    loadData();

  }, [token, authFetch]);

  // =========================
  // FILTROS
  // =========================
const filtered = assignments.filter((item) => {

  const matchContract =
    !filterContract || String(item.contract) === String(filterContract);

  const matchProgram =
    !filterProgram || String(item.program_assignment) === String(filterProgram);

  const matchCostCenter =
    !filterCostCenter || String(item.cost_center_id) === String(filterCostCenter)

  return matchContract && matchProgram && matchCostCenter;
});

  const totalPages = Math.ceil(filtered.length / recordsPerPage);

  const currentRecords = filtered.slice(
    (currentPage - 1) * recordsPerPage,
    currentPage * recordsPerPage
  );

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  // =========================
  // MODAL
  // =========================
  const openModal = () => {
    const modalEl = document.getElementById("createAssignmentModal");
    modalInstance = new bootstrap.Modal(modalEl);
    modalInstance.show();
  };

  const closeModal = () => {
    const modalEl = document.getElementById("createAssignmentModal");
    modalInstance = bootstrap.Modal.getInstance(modalEl);
    modalInstance.hide();

    setFormData({
        contract: "",
        program_assignment: "",
        cost_center: ""
    });
  };

  // =========================
  // CREAR
  // =========================
  const handleCreate = async () => {

    if (!formData.contract ||  !formData.program_assignment || !formData.cost_center) {
      alert("Todos los campos son obligatorios");
      return;
    }

    try {
      const response = await authFetch(ENDPOINTS.createAssignment, {
        method: "POST",
        body: JSON.stringify(formData)
      });

      if (response.success) {
        alert("Asignación creada correctamente");
        closeModal();

        const reload = await authFetch(ENDPOINTS.getAssignment);
        if (reload.success) setAssignments(reload.data);

      } else {
        alert(response.message);
      }

    } catch (error) {
      console.error(error);
      alert("Error de servidor");
    }
  };

  // =========================
  // OPTIONS
  // =========================
  const contractOptions = contracts.map(c => ({
    value: c.id_contrato,
    label: `${c.num_contrato} - ${c.entidad}`
  }));

  const programOptions = programs.map(p => ({
    value: p.id,
    label: `${p.program_name} - ${p.area_name}`
  }));

  const costCenterOptions = costCenters.map(cc => ({
    value: cc.id,
    label: `${cc.cost_center} - ${cc.name_cost_center} - ${cc.type_cost_center}`
  }));

  // =========================
  // RENDER
  // =========================
  if (loading) return <p>Cargando asignaciones...</p>;

  return (
    <div className="container mt-4 p-4">

      <div className="d-flex justify-content-between mb-3">
        <h2>Asignaciones de los contratos</h2>

        <button className="btn btn-outline-pink" onClick={openModal}>
          Crear asignación
        </button>
      </div>

      {/* FILTROS */}
      <div className="row mb-3">

        <div className="col-md-4">
          <label>Contrato</label>
            <SearchSelect
                options={[
                    { value: "", label: "Todos" },
                    ...contractOptions
                ]}
                value={filterContract}
                onChange={(val) => setFilterContract(val)}
                placeholder="Buscar contrato..."
            />
        </div>

        <div className="col-md-4">
            <label>Programa</label>
            <SearchSelect
                options={[
                { value: "", label: "Todos" },
                ...programOptions
                ]}
                value={filterProgram}
                onChange={(val) => setFilterProgram(val)}
                placeholder="Buscar programa..."
            />
        </div>

        <div className="col-md-4">
            <label>Centro de costos</label>
            <SearchSelect
                options={[
                  { value: "", label: "Todos" },
                  ...costCenterOptions
                ]}
                value={filterCostCenter}
                onChange={(val) => setFilterCostCenter(val)}
                placeholder="Buscar centro de costo..."
              />
        </div>

      </div>

      {/* TABLA */}
      <table className="table table-hover">
        <thead className="table-secondary">
          <tr>
            <th>ID</th>
            <th>Contrato</th>
            <th>Programa y área</th>
            <th>Centro de costo</th>
            <th>Fecha de asignación</th>
          </tr>
        </thead>

        <tbody>
          {currentRecords.map(a => (
            <tr key={a.id_asignacion}>
              <td>{a.id_asignacion}</td>
              <td># {a.num_contrato}</td>
              <td>{a.program_name} - {a.area_name}</td>
              <td>{a.cost_center}</td>
              <td>{new Date(a.created_at).toLocaleDateString()}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={goToPage}
      />

      {/* MODAL */}
      <div className="modal fade" id="createAssignmentModal" tabIndex="-1">
        <div className="modal-dialog">
          <div className="modal-content">

            <div className="modal-header">
              <h5>Crear Asignación</h5>
              <button className="btn-close" onClick={closeModal}></button>
            </div>

            <div className="modal-body">

              <div className="mb-3">
                <label>Contrato</label>
                <SearchSelect
                    options={contractOptions}
                    value={formData.contract}
                    onChange={(val) =>
                        setFormData(prev => ({ ...prev, contract: val }))
                    }
                    placeholder="Buscar contrato..."
                />
              </div>

              <div className="mb-3">
                <label>Programa</label>
                <SearchSelect
                    options={programOptions}
                    value={formData.program_assignment}
                    onChange={(val) =>
                        setFormData(prev => ({ ...prev, program_assignment: val }))
                    }
                    placeholder="Buscar programa..."
                />
              </div>

              <div className="mb-3">
                <label>Centro de costo</label>
                <SearchSelect
                  options={costCenterOptions}
                  value={formData.cost_center}
                  onChange={(val) =>
                    setFormData(prev => ({
                      ...prev,
                      cost_center: val
                    }))
                  }
                  placeholder="Buscar centro de costo..."
                />
              </div>

            </div>

            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={closeModal}>
                Cancelar
              </button>
              <button className="btn btn-outline-pink" onClick={handleCreate}>
                Crear
              </button>
            </div>

          </div>
        </div>
      </div>

    </div>
  );
};

export default Assignment;